"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VbzSkeleton = exports.VbzSkeletonContent = void 0;
const react_1 = __importDefault(require("react"));
const className_1 = require("../../utils/className");
exports.VbzSkeletonContent = ({ className, style }) => {
    return (react_1.default.createElement("div", { style: style, className: className_1.mapToCssModules(['skeleton-content', className]) }));
};
exports.VbzSkeleton = ({ ready = false, className, style, children, renderLoadingContent, }) => {
    return (react_1.default.createElement(react_1.default.Fragment, null, ready ? (children) : (react_1.default.createElement("div", { className: className_1.mapToCssModules([
            'skeleton-container',
            'pulse-animation',
            className,
        ]), style: style }, renderLoadingContent === null || renderLoadingContent === void 0 ? void 0 : renderLoadingContent()))));
};
exports.VbzSkeleton.Content = exports.VbzSkeletonContent;
//# sourceMappingURL=index.js.map